export default "__VITE_ASSET__C1a2WUBY__"